module.exports = __webpack_public_path__ + "media/images/athletes/1748-c58accb4c0d8c3c2b47535fe2ce4f862.png";